import React from 'react';

import {ReactComponent as Canceled} from 'shared/assets/cross-outlined.svg';
import {ReactComponent as Error} from 'shared/assets/error.svg';
import {ReactComponent as Reject} from 'shared/assets/minus.svg';
import {ReactComponent as OnHold} from 'shared/assets/on-hold.svg';
import {ReactComponent as Pending} from 'shared/assets/pending-icon.svg';
import {ReactComponent as Running} from 'shared/assets/running.svg';
import {ReactComponent as Success} from 'shared/assets/tick.svg';
import {ReactComponent as Warning} from 'shared/assets/warning.svg';
import {EMonitoringStatusCode, EStageStatus} from 'store/slices/documents-uploading-slice';

export interface IDocumentsUploadStageProps {
    status: EStageStatus | EMonitoringStatusCode;
}

export const DocumentsUploadStatusIcon = ({status}: IDocumentsUploadStageProps) => {
    switch (status) {
    case EStageStatus.pending:
        return <Pending />;
    case EStageStatus.reject:
        return <Reject />;
    case EStageStatus.success:
    case EMonitoringStatusCode.normal:
        return <Success />;
    case EMonitoringStatusCode.onHold:
        return <OnHold />;
    case EMonitoringStatusCode.warning:
        return <Warning />;
    case EMonitoringStatusCode.error:
        return <Error />;
    case EMonitoringStatusCode.running:
        return <Running />;
    default:
        return <Canceled />;
    }
};
